module.exports = __webpack_public_path__ + "img/Degu.af0a0ccf.jpg";